import httpService from "./httpService";

export default {
  saveAllLocations(signingLocations) {
    return httpService.post("signingLocationUser/saveAll", signingLocations);
  },

  findAllLocationByUserIdAndDocId(userId, docId) {
    return httpService.get("signingLocationUser/findAllByUserIdAndDocId", {
      params: {
        userId: userId,
        docId: docId
      }
    });
  },
  getFileInputStream(signedDocId){
    return httpService.get("signingConfig/getFileInputStream",{params: {signedDocId: signedDocId}})
  },
  replaceSignedFile(formReplaceFile){
    return httpService.post("signingConfig/replaceFile", formReplaceFile);
  },
  getLatestSignedFile(outgoingDocId){
    return httpService.get("signingConfig/getLatestSignedFile", {params: {outgoingDocId: outgoingDocId}});
  },
};



// WEBPACK FOOTER //
// ./src/services/signingLocationUserService.js